module.exports = __webpack_public_path__ + "img/Medieval_Sword_Scimitar.b48f549c.png";